import React from 'react';

import { ScreenLink } from '@gogame/screens';

import { spendAdjustmentDetailsLink } from 'scenes/SpendAdjustments/navigation';

export const SpendAdjustmentsLink = ({
  relatedActionId,
  onClick,
  children,
  ...props
}) => {
  return (
    <ScreenLink
      link={spendAdjustmentDetailsLink}
      params={{
        id: relatedActionId,
        searchQuery: relatedActionId,
      }}
      target={'_blank'}
      fast={true}
      onClick={onClick}
      {...props}
    >
      {children}
    </ScreenLink>
  );
};
